import React from 'react';

export const name = 'receive';

export const Receive = () => (
  <svg
    viewBox="0 0 32 32"
    fill="none"
    color="#161619"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.40984 16H24.9398L27.5898 20.68"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M11.7498 8.65991L4.40976 15.9999L11.7498 23.3399"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
